import { notification } from 'antd';
import { BusinessOffersService } from '@/modules/offer/services/business-offers.service';
import { DiContainer } from '@/modules/di/di-container';
import {
  BestPriceBuyerItem,
  IBestPriceBagItem,
} from '@/modules/mixing/store/analytical-mixing.store';
import { IExclusiveRecipe } from '@/widgets/recipe/types';
import { BusinessOfferActionType } from '@/modules/offer/types/business-offer';
import { indicateWheatType } from '@/modules/common/helpers/wheat-type.helper';

const businessOffersService = DiContainer.get(BusinessOffersService);

export const createMixOfferFoo = async (
  data: IExclusiveRecipe,
  action: BusinessOfferActionType,
  signature?: string,
  mixed_properties?: { name: string; value: string; units: string }[],
) => {
  try {
    const bagsObj: { id: number; warehouse_id: number; weight: number }[] = [];
    data.components.map((comp) => bagsObj.push(...comp.bags));
    const resultBags = bagsObj.reduce((acc, sleeveData) => {
      //@ts-ignore
      acc[sleeveData.id] = sleeveData.weight;
      return acc;
    }, {});
    const res: any = await businessOffersService.createBusinessOffer({
  action,
  bunkerreloaders_ids: data.bunkerreloaders_ids,
  mix: true,
  mix_id: data.id,
  distance: data.distance,
  price_logistic: data.price_logistic,
  mixing_profit: data.mixing_profit,
  mixed_properties: data.mixed_properties,
  price_netto: data.price_netto,
  price_all: data.price_all,
  is_remnants: false,
  warehouse_id: data.warehouse_id,
  destination_id: data.destination_id,
  price_id: data.price_id,
  company_name: data.buyer_company,
  wheat_class: `${data.mixed_properties.find(item => item.name === 'Класс')?.value || 0}-класс`,
  wheat_type: String(indicateWheatType(data.sort, data.type)),
  weight: data.weight,
  initial_weight_gain_tons: 0,
  price: data.price_per_ton,
  bags: resultBags,
  weight_gain_tons: 0,
  mix_signature: signature,
  freight_cost_after_moisture_mod: 0,
  freight_cost_before_moisture_mod: 0,
  initial_price_logistic: data.price_logistic || 0,
  action_place: null,
  new_nature: 0,
  status: data.status,
});
    if (res.id) {
      notification.success({ message: 'Сделка успешно создана' });
      return;
    }
    return notification.warning({
      message: 'Ошибка',
      description: 'при создании сделки возникла ошибка. Попробуйте позже',
    });
  } catch (err) {
    return notification.warning({
      message: 'Ошибка',
      description: 'при создании сделки возникла ошибка. Попробуйте позже',
    });
  }
};
